module.exports = __webpack_public_path__ + "img/pci.712f38b2.svg";